(function () {
  'use strict';

  var ICON_HTML =
    '<span class="dd-acc-icon" aria-hidden="true">' +
      '<svg class="dd-acc-icon__plus" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' +
        '<line x1="7" y1="3" x2="7" y2="11"/><line x1="3" y1="7" x2="11" y2="7"/>' +
      '</svg>' +
      '<svg class="dd-acc-icon__minus" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' +
        '<line x1="3" y1="7" x2="11" y2="7"/>' +
      '</svg>' +
    '</span>';

  function init() {
    var container = document.querySelector('.product__description');
    if (!container) return;

    var headings = container.querySelectorAll('h4');
    if (!headings.length) return;

    var children = Array.from(container.childNodes);
    var fragment = document.createDocumentFragment();
    var currentDetails = null;
    var currentContent = null;
    var hasLeadContent = false;

    for (var i = 0; i < children.length; i++) {
      var node = children[i];

      if (node.nodeType === 1 && node.tagName === 'H4') {
        if (currentDetails) fragment.appendChild(currentDetails);

        currentDetails = document.createElement('details');
        currentDetails.className = 'dd-desc-accordion';

        var summary = document.createElement('summary');
        var title = document.createElement('span');
        title.className = 'dd-desc-accordion__title';
        title.textContent = node.textContent;
        summary.appendChild(title);
        summary.insertAdjacentHTML('beforeend', ICON_HTML);

        currentDetails.appendChild(summary);

        currentContent = document.createElement('div');
        currentContent.className = 'dd-desc-accordion__body';
        currentDetails.appendChild(currentContent);
        continue;
      }

      if (currentContent) {
        currentContent.appendChild(node.cloneNode(true));
      } else {
        hasLeadContent = true;
        fragment.appendChild(node.cloneNode(true));
      }
    }

    if (currentDetails) fragment.appendChild(currentDetails);

    container.innerHTML = '';
    container.appendChild(fragment);

    if (hasLeadContent) {
      container.classList.add('dd-desc-has-lead');
    }

    wireAnimations(container);
  }

  /**
   * Animate each <details> open/close. The native element snaps instantly —
   * we intercept the summary click, measure the body, and transition
   * `height` from 0 ↔ scrollHeight before toggling the `open` attribute.
   * Respect prefers-reduced-motion by bailing to default behavior.
   */
  function wireAnimations(container) {
    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    var accordions = container.querySelectorAll('.dd-desc-accordion');
    for (var i = 0; i < accordions.length; i++) {
      wireOne(accordions[i]);
    }
  }

  function wireOne(details) {
    var summary = details.querySelector('summary');
    var body = details.querySelector('.dd-desc-accordion__body');
    if (!summary || !body) return;

    var animating = false;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (animating) return;

      if (details.open) {
        collapse();
      } else {
        expand();
      }
    });

    function expand() {
      animating = true;
      details.open = true;
      // Lock to 0 → scrollHeight, then release to `auto` when the
      // transition completes so nested content can reflow freely.
      body.style.height = '0px';
      // Force layout so the browser picks up the starting height before we
      // change it — otherwise the transition gets skipped entirely.
      // eslint-disable-next-line no-unused-expressions
      body.offsetHeight;

      requestAnimationFrame(function () {
        body.style.height = body.scrollHeight + 'px';
      });

      onEnd(function () {
        body.style.height = '';
        animating = false;
      });
    }

    function collapse() {
      animating = true;
      body.style.height = body.scrollHeight + 'px';
      // eslint-disable-next-line no-unused-expressions
      body.offsetHeight;

      requestAnimationFrame(function () {
        body.style.height = '0px';
      });

      onEnd(function () {
        details.open = false;
        body.style.height = '';
        animating = false;
      });
    }

    function onEnd(cb) {
      function handler(ev) {
        if (ev.target !== body || ev.propertyName !== 'height') return;
        body.removeEventListener('transitionend', handler);
        cb();
      }
      body.addEventListener('transitionend', handler);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
